import React from 'react'
import { useConfigStore } from '@renderer/stores/configState'

interface BackgroundContainerProps {
  children: React.ReactNode
  className?: string
}

export const BackgroundContainer: React.FC<BackgroundContainerProps> = ({
  children,
  className = ''
}) => {
  const { config } = useConfigStore()
  
  const backgroundStyle: React.CSSProperties = {
    backgroundColor: config?.theme.backgroundColor || '#F8FAFC',
    ...(config?.theme.backgroundImageUrl && {
      backgroundImage: `url(${config.theme.backgroundImageUrl})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    })
  }
  
  return (
    <div
      className={`w-full h-full ${className}`}
      style={backgroundStyle}
    >
      {children}
    </div>
  )
}

// Glass panel for popup sections with glassmorphism effect
interface GlassPanelProps {
  children: React.ReactNode
  className?: string
  /** Merged over default glass styles (e.g. lighter panel on Edit) */
  style?: React.CSSProperties
}

export const GlassPanel: React.FC<GlassPanelProps> = ({
  children,
  className = '',
  style: styleProp
}) => {
  return (
    <div
      className={`backdrop-blur-xl rounded-2xl border shadow-2xl ${className}`}
      style={{
        background: 'rgba(255, 255, 255, 0.75)',
        borderColor: 'rgba(255, 255, 255, 0.3)',
        boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.15)',
        ...styleProp
      }}
    >
      {children}
    </div>
  )
}

